import * as React from "react";
const SvgTrendingFlat = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m22 12-4-4v3H3v2h15v3l4-4z",
  fill: "currentColor"
}));
export default SvgTrendingFlat;